<template>
  <el-dialog class="del-dialog" :width="width" :visible.sync="dialogVisible" :show-close="showClose"
             :before-close="handleClose" @closed="handleClosed" @open="handleOpen">
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>
      <slot name="title">{{$t('common.tips')}}</slot>
      <div class="title-right"></div>
    </div>
    <slot></slot>
    <div slot="footer" v-show="showButton">
      <el-button @click="handleClose">
        <slot name="close">{{$t('common.cancel')}}</slot>
      </el-button>
      <el-button type="primary" :class="dialogType=='delete'?'confirm-btn':''"
                 v-show="showConfirmButton" @click="handleConfirm">
        <slot name="confirm">{{$t('common.ok')}}</slot>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'Dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    width: {
      type: String,
      default() {
        return '480px';
      },
    },
    dialogType: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showButton: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showConfirmButton: {
      type: Boolean,
      default() {
        return true;
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleClose');
    },
    handleConfirm: _.throttle(async function () {
      this.$emit('handleConfirm');
    }, 1500, {
      leading: true,
      trailing: false
    }),
    handleClosed() {
      this.$emit('handleClosed');
    },
    handleOpen() {
      this.$emit('handleOpen');
    },
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>